import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TraceClassDecorator } from "@sentry/angular";
import { URLS } from "src/app/constant/constant";
import { ProviderStateService } from "src/app/services/provider-state.service";
import { UtilitiesService } from "src/app/utilities/utilities.service";


@Component({
    selector: "app-home-footer",
    templateUrl: "./home-footer.component.html",
    styleUrls: [
        "./home-footer.component.css",
        "./../../portal-home/login-home/login-home.component.css",
    ],
})
@TraceClassDecorator()
export class HomeFooterComponent implements OnInit {
    year: number;
    is_primary_provider: boolean = false;
    slug: string = "";
    is_uk_country: boolean = false;
    constructor(
        private router: Router,
        private utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) {
        this.year = new Date().getFullYear();

    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        if(URLS.IS_UK)
        {
            this.is_uk_country = true;
        }
        if (this.is_primary_provider) {
            this.getCurrentYear();

        }
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/' + path]);
    }

    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }

    getCurrentYear(): void {
        this.year = new Date().getFullYear();
    }


}
